import type { ComponentProps } from 'react';
import { FormattedMessage as BaseFormattedMessage } from 'react-intl';
import type { TranslationKey } from '../locales-config';

type FormattedMessageProps = ComponentProps<typeof BaseFormattedMessage>;

export const FormattedMessage = (props: Omit<FormattedMessageProps, 'id'> & { id: TranslationKey }) => (
  <BaseFormattedMessage {...props} />
);
